import { render, staticRenderFns } from "./PuzzlePieces.vue?vue&type=template&id=6e6a68c2&scoped=true&"
import script from "./PuzzlePieces.vue?vue&type=script&lang=js&"
export * from "./PuzzlePieces.vue?vue&type=script&lang=js&"
import style0 from "./PuzzlePieces.vue?vue&type=style&index=0&id=6e6a68c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6a68c2",
  null
  
)

export default component.exports